import {KidsV2Service} from "@/services/KidsV2Service";

const state = {
  isLoading: true,
  pagination: {
    from: 1,
    to: 15,
    currentPage: 1,
    lastPage: 0,
    perPage: 15,
    total: 0
  },

};


const mutations = {
  SET_IS_LOADING: (state, isLoading) => state.isLoading = isLoading,
  setPagination: (state, data) => {
    state.pagination = {
      from: data?.from,
      to: data?.to,
      currentPage: data?.current_page,
      lastPage: data?.last_page,
      perPage: data?.per_page,
      total: data?.total
    };
  },
};


const actions = {
  setLoading({ commit }, loading) {
    commit('SET_IS_LOADING', loading);
  },

  async generateSSOToken({ commit }, params) {
    const { default: Swal } = await import('sweetalert2')
    try {
      // Some callers (Loss.vue's Visit Medical Report flow) already
      // have a loader open before this action runs - showing their own
      // "Checking..."/"Preparing..."/"Opening..." copy that shouldn't be
      // replaced by a fresh modal (see
      // FIX_REQUEST...CreateMedicalReportLoaderDelay.md - the two-phase
      // loader is one continuous modal, not a close/re-open). Other callers
      // (e.g. the sidebar's plain "Medical Report" link) call this action
      // directly with nothing pre-opened, so this still needs to open its
      // own loader for them exactly as before.
      if (Swal.isVisible()) {
        Swal.update({ title: 'Connecting to the Medical Report module' });
        Swal.showLoading();
      } else {
        Swal.fire({
          title: 'Connecting to the Medical Report module',
          text: 'Preparing your secure session, please wait...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
      }

      const response = await KidsV2Service.generateSSOToken();

      if (response && response.status >= 200 && response.status < 300) {
        const ssoToken = response.data.sso_id;
        const targetBaseUrl = process.env.VUE_APP_KIDS_V2_APP_URL;

        const searchParams = new URLSearchParams({
          redirect_path_name: params.redirect_path_name,
          sso_token: ssoToken,
          user_legacy_id: params.user_id,
        });

        // Optional accident/incident<->medical report handoff context (see
        // BUILD_REQUEST_Backend_AccidentIncident_MedicalLink.md, A2) - only
        // appended when the caller actually passes one, so every existing
        // call site (the MEDICAL REPORT sidebar link, which passes neither)
        // keeps building the exact same URL it always has.
        ['accident_incident_id', 'accident_incident_report_number', 'crew_external_id', 'medical_report_id', 'vessel_legacy_kids_id', 'event_date', 'place', 'accident_personnel_id'].forEach((key) => {
          if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
            searchParams.set(key, params[key]);
          }
        });

        const redirectUrl = `${targetBaseUrl}login?${searchParams.toString()}`;
        Swal.close();

        // Loss.vue's Visit Medical Report opens its tab during the
        // click (one tab per crew row, reused on the next click) and passes
        // it here to be sent to the page - unless the user closed it in the
        // meantime. That tab keeps its link back to this page (no noopener),
        // which is what lets the next click find it again. Every other caller
        // gets a new tab, as before.
        if (params.targetWindow) {
          if (params.targetWindow.closed) return false;
          params.targetWindow.location.replace(redirectUrl);
        } else {
          window.open(redirectUrl, '_blank', 'noopener,noreferrer');
        }
        return true;

      } else {
        Swal.fire({
          icon: 'error',
          title: 'Connection Failed',
          text: 'Could not generate a secure token. Please try again.',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'System Error',
        text: 'An unexpected connection error occurred.',
      });
      console.error("Critical error in generateSSOToken method:", error);
    }
    return false;
  }
};


const getters = {
  isLoading: state => state.isLoading,
  pagination: (state) => state.pagination,

};


export default {state, actions, mutations, getters};
